import { HTMLAttributes, JSX } from 'react';

import { useLang } from '@/hooks/useLang';

interface DetailTextWrapperType extends HTMLAttributes<HTMLDivElement> {
  title: string;
  title_color?: string;
  date?: string;
  year?: string | null;
  children: JSX.Element[] | JSX.Element;
  subline?: JSX.Element | string;
  city?: string | null;
  translateButton?: JSX.Element[] | JSX.Element;
  titleRight?: JSX.Element | null;
}
const DetailTextWrapper = ({
  title,
  date,
  year,
  children,
  className,
  city,
  translateButton,
  subline,
  titleRight,
  ...props
}: DetailTextWrapperType) => {
  const { currentLang } = useLang();
  return (
    <div
      className={`${className}`}
      {...props}
    >
      <div className="text-sm">
        <div className="flex items-center justify-between gap-3">
          <div className="min-w-0 flex-1 text-2xl text-pretty wrap-break-word text-(--accentColor)">{title}</div>
          {titleRight && <div className="shrink-0">{titleRight}</div>}
        </div>

        {subline && <div className="mt-1 mb-2">{subline}</div>}

        <div className="mt-1 flex items-start justify-between">
          <div className="text-gray-500">
            {city && city}
            {city && date && ', '}
            {date &&
              `${new Date(date).toLocaleDateString(currentLang, {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
              })}`}
            {year && (date ? `, ${year}` : ` · ${year}`)}
          </div>

          <div className="max-w-1/2 shrink grow-0 wrap-anywhere">{translateButton}</div>
        </div>
      </div>

      {children}
    </div>
  );
};

export default DetailTextWrapper;
